module.exports = __webpack_public_path__ + "static/media/profile_21.3a291364.jpg";